import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { ProgressProvider } from './contexts/ProgressContext';
import { ToastProvider } from './components/shared/Toast';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ProgressProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ProgressProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
